import { whyLLK } from "@/mocks/llkContent";
import { ScrollReveal } from "@/components/animations/ScrollReveal";
import { StaggerContainer, StaggerItem } from "@/components/animations/StaggerContainer";

export default function WhyLLKSection() {
  return (
    <section className="relative py-20 md:py-28 bg-llk-cream-2">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <ScrollReveal>
            <p className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-llk-gold-dark mb-4">
              DIFERENCIAL LLK
            </p>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-llk-dark font-semibold mb-4">
              Tecnologia, consultoria e resultado no mesmo manejo
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={0.2}>
            <p className="text-llk-dark/60 text-base md:text-lg max-w-2xl mx-auto">
              A LLK une visão técnica, campo e soluções biológicas premium para ajudar produtores a evoluírem seus manejos com segurança, eficiência e sustentabilidade.
            </p>
          </ScrollReveal>
        </div>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" staggerDelay={0.12} delayChildren={0.15}>
          {whyLLK.map((item) => (
            <StaggerItem key={item.title}>
              <div className="group p-6 md:p-8 rounded-2xl bg-white border border-llk-earth-pale/40 transition-all duration-500 hover:shadow-lg hover:border-llk-gold/20 h-full">
                <div className="w-12 h-12 rounded-xl bg-llk-dark flex items-center justify-center mb-5 group-hover:bg-llk-gold transition-colors">
                  <i className={`${item.icon} text-xl text-white group-hover:text-llk-dark transition-colors`} />
                </div>
                <h3 className="text-lg font-semibold text-llk-dark mb-2">{item.title}</h3>
                <p className="text-llk-dark/60 text-sm leading-relaxed">{item.description}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}